module.exports = __webpack_public_path__ + "static/media/l.0f131be3.png";